var FILE_TYPES = {
  image: {
    name: "Image",
    fileExtensions: ['png', 'jpg', 'jpeg', 'gif', 'tiff']
  },
  subdocument: {
    name: "Subdocument",
    fileExtensions: ['xfc', 'epb']
  },
  documentMerge: {
    name: "Document",
    fileExtensions: ['pdf', 'ps', 'docx', 'doc', 'html', 'fo']
  }
};
export var getTypeExtensions = function getTypeExtensions(_ref) {
  var fileTypes = _ref.fileTypes,
      fileExtensions = _ref.fileExtensions;
  var extensions = [];

  if (fileTypes) {
    fileTypes.map(function (fileType) {
      return extensions = extensions.concat(FILE_TYPES[fileType].fileExtensions);
    });
  }

  if (fileExtensions) extensions = extensions.concat(fileExtensions);
  return Array.from(new Set(extensions));
};
export var getTypeFriendlyName = function getTypeFriendlyName(props) {
  var fileTypes = props.fileTypes,
      fileExtensions = props.fileExtensions,
      pickType = props.pickType;
  if (pickType === 'folder') return 'folder';
  if (fileExtensions && fileExtensions.length > 0) return 'file';
  if (!fileTypes) return 'file';
  if (fileTypes.length > 1) return 'file';
  return FILE_TYPES[fileTypes[0]].name;
};
export default FILE_TYPES;